module.exports = __webpack_public_path__ + "static/media/trioRoundDetailes.019f7ee0.png";